import React from "react";
import { Breadcrumb, BreadcrumbItem } from "reactstrap";

const Breadcrumbs = ({ title, breadcrumbItem }) => {
  return (
    <div className="page-title-box">
      <div className="row align-items-center">
        <div className="col-sm-6">
          <h4 className="mb-0">{breadcrumbItem}</h4>
        </div>
        <div className="col-sm-6">
          <Breadcrumb className="float-end">
            <BreadcrumbItem>{title}</BreadcrumbItem>
            <BreadcrumbItem active>{breadcrumbItem}</BreadcrumbItem>
          </Breadcrumb>
        </div>
      </div>
    </div>
  );
};

export default Breadcrumbs;
